// extracted by mini-css-extract-plugin
module.exports = {"boxCatalog":"BoxCatalog_boxCatalog__LU8Jz"};